export default __webpack_public_path__ + "static/logo-kraken-dffe24bbf9a31fc9d44455ac60e92f08.png";